import { Fragment, useContext, useMemo } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { makeStyles } from 'tss-react/mui';
import MenuItem from './menuItem';
import { AuthContext } from '../../../context/auth';
import People from '@mui/icons-material/People';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import TagRoundedIcon from '@mui/icons-material/TagRounded';
import BiotechRoundedIcon from '@mui/icons-material/BiotechRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

const useStyles = makeStyles()((theme) => ({
    container: {
        overflow: "hidden auto",
        margin: "8px 0",
    },
    headerExpandible: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
        paddingLeft: "55px",
    },
    divider: {
        margin: "8px 0",
    }
}));

export default function Main() {
    const { usuario } = useContext(AuthContext);
    const { classes } = useStyles();

    const isAdminVisible = useMemo(() => {
        if (!usuario) return false;
        return usuario.nivel_usuario === 1 || usuario.sup_usuarios === true;
    }, [usuario]);

    const isUsuariosDisabled = useMemo(() => {
        if (!usuario) return true;
        return !(usuario.nivel_usuario === 1 || usuario.sup_usuarios === true);
    }, [usuario]);

    const menuItems = [
        {
            label: "Inicio",
            visible: !!usuario,
            items: [
                {
                    label: "Panel de Inicio",
                    icon: DashboardIcon,
                    url: "/dashboard",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Liquidación",
            visible: !!usuario,
            items: [
                {
                    label: "NHPdGD (generador)",
                    icon: ReceiptLongRoundedIcon,
                    url: "/nhpdgd",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Catálogo de prácticas",
            visible: !!usuario,
            items: [
                {
                    label: "Sectores",
                    icon: CategoryRoundedIcon,
                    url: "/determinacion-grupo",
                    visible: true,
                    disabled: false,
                    list: []
                },
                {
                    label: "Códigos de práctica",
                    icon: TagRoundedIcon,
                    url: "/codigo",
                    visible: true,
                    disabled: false,
                    list: []
                },
                {
                    label: "Determinaciones",
                    icon: BiotechRoundedIcon,
                    url: "/determinacion",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Administración",
            visible: isAdminVisible,
            items: [
                {
                    label: "Usuarios",
                    icon: People,
                    url: "/usuario",
                    visible: true,
                    disabled: isUsuariosDisabled,
                    list: []
                },
            ],
        },
    ];

    return (
        <div className={classes.container}>
            { menuItems.map((seccion) => (
                seccion.visible ?
                    <Fragment key={`seccion-${seccion.label}`}>
                        <ListSubheader inset className={classes.headerExpandible}> {seccion.label} </ListSubheader>

                        {seccion.items.map((item) => (
                            item.visible ?
                                <Fragment key={`item-${item.url || item.label}`}>
                                    <MenuItem url={item.url} label={item.label} Icon={item.icon} disabled={item.disabled} />
                                    <List component="div" disablePadding>
                                        { item.list.map((subitem) => (
                                            subitem.visible ?
                                                <MenuItem
                                                    key={`subitem-${(item.url || '') + (subitem.url || subitem.label)}`}
                                                    url={(item.url || '') + (subitem.url || '')}
                                                    label={subitem.label}
                                                    Icon={subitem.icon}
                                                    disabled={subitem.disabled}
                                                    sx={{ pl: 7 }}
                                                />
                                            : null
                                        ))}
                                    </List>
                                </Fragment>
                            : null
                        ))}
                    </Fragment>
                : null
            ))}
        </div >
    );
}
